import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';

import styles from '@styles/punch.module.css';
import PunchCCQForm from '@components/punchCCQ/PunchCCQForm';
import PunchCCQProjectList from '@components/punchCCQ/PunchCCQProjectList'
import AlertAlgo from '@components/controls/AlertSnack';
import * as punchListType from '@scripts/PunchListType';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    titleTemplate: {
        fontSize: '20px',
        '@media (max-width: 600px)': {
            fontSize: '15px',
        }
    }
}));

export function PunchCCQProject(props) {
    const classes = useStyles();
    const alertRef = useRef(null);

    const [isActive, setIsActive] = useState(true);
    const [openPunchingCCQ, setOpenPunchingCCQ] = useState(false);
    const [loader, setLoader] = useState(0);

    useEffect(() => {
        loadPage();
    }, []);

    const loadPage = () => {
        setIsActive(false);
    }

    const handleClosePunchingCCQ = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenPunchingCCQ(false);
        setLoader(loader + 1);
    }

    return (
        <LoadingOverlay className={classes.divLoading} active={isActive} spinner={<BeatLoader />} text={i18next.t('punch:form.loading')}>
            <div id="divPunchRoot" className={styles.punchCcqWrapper}>
                {
                    <div data-id="divPunch" className={styles.divPunchForm}>
                        <PunchCCQProjectList punchListType={punchListType.DAY} loader={loader}></PunchCCQProjectList>

                        {
                            openPunchingCCQ && <Dialog fullScreen open={openPunchingCCQ} onClose={handleClosePunchingCCQ} TransitionComponent={Transition}>
                                <AppBar className={classes.appBar}>
                                    <Toolbar>
                                        <IconButton edge="start" color="inherit" onClick={handleClosePunchingCCQ} aria-label="close">
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography variant="h6" className={classes.title}>
                                            {i18next.t('punchCCQ:button.punch')}
                                        </Typography>
                                    </Toolbar>
                                </AppBar>

                                <div className={styles.rootPunchCCQ}>
                                    <PunchCCQForm onClose={handleClosePunchingCCQ} />
                                </div>
                            </Dialog>
                        }
                    </div>
                }
                <AlertAlgo ref={alertRef} />
            </div>
        </LoadingOverlay>
    )
}

export default withNamespaces(['punch', 'punchCCQ'], { wait: true })(PunchCCQProject);